<template>
  <v-card min-width="35vw" align="center" justify="center" light outlined>
    <v-card-title style="background-color: #d2d7e1">
      <v-list-item>
        <v-list-item-title>
          <h2>{{ club.name }}'s Community</h2>
        </v-list-item-title>
        <v-spacer />
        <v-list-item-action>
          <v-icon class="icon" @click="closeWindow" icon>fa-times</v-icon>
        </v-list-item-action>
      </v-list-item>
    </v-card-title>
    <v-card-text class="pt-3 pb-1">
      <v-container fluid>
        <v-row>
          <v-col cols="6" xl="4" lg="4" md="4">
            <h3>ID</h3>
            <p>{{ club.id }}</p>
            <h3 :class="$store.state.desktop ? 'mt-7' : ''">Pro Expiration</h3>
            <p>{{ club.proExpirationTime.substr(0, 10) }}</p>
          </v-col>
          <v-col cols="6" xl="4" lg="4" md="4">
            <h3>Name</h3>
            <p>{{ club.name }}</p>
            <h3 :class="$store.state.desktop ? 'mt-7' : ''">Threshold</h3>
            <p>{{ club.threshold }}</p>
          </v-col>
          <v-col cols="12" xl="4" lg="4" md="4">
            <h3>Creation Date</h3>
            <p>{{ club.createdAt.substr(0, 10) }}</p>
            <h3 :class="$store.state.desktop ? 'mt-7' : ''">Club Package</h3>
            <p>{{ club.clubPackage.name }}</p>
          </v-col>
        </v-row>
        <v-row class="d-flex justify-start">
          <v-col>
            <h3>Description</h3>
            <p>{{ club.description }}</p>
          </v-col>
        </v-row>
        <v-row class="d-flex justify-center">
          <v-btn @click="closeWindow">Close</v-btn>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "ShowClubInfo",
  props: {
    club: Object,
  },
  mounted() {},
  methods: {
    closeWindow() {
      this.$emit("closeWindow");
    },
  },
};
</script>

<style scoped>
</style>
